module.exports = __webpack_public_path__ + "img/13e953c5cee276ec5c459220fbd8cd76.svg";